module.exports = __webpack_public_path__ + "static/media/EE.3f4c83e2.svg";